import { useReducer } from 'react';
import { Box, Center } from '@chakra-ui/react';
import { AnimatePresence, motion } from 'framer-motion';

import SunshineIcon from 'components/_core/SunshineIcon';
import {
  BANK_ACCOUNT_ILLUSTRATIONS,
  BankAccountIllustrationsType,
} from 'components/BankAccountIcon/constants';

import { AnimationPropsType } from '../BankAccountForm';
import IllustrationPickerSidebar, {
  IllustrationNameField,
} from './components/IllustrationPickerSidebar';

interface BankAccountIllustrationPickerProps {
  field: IllustrationNameField;
  animationIllustration: string;
  animationProps: AnimationPropsType;
  setFieldHasBeenTouched: (value: boolean) => void;
}

const BankAccountIllustrationPicker = ({
  animationIllustration,
  animationProps,
  field,
  setFieldHasBeenTouched,
}: BankAccountIllustrationPickerProps) => {
  const [isOpenIllustrationSidebar, toggleSidebar] = useReducer(
    (state) => !state,
    false,
  );

  const handleClick = () => {
    setFieldHasBeenTouched(true);
    toggleSidebar();
  };

  return (
    <>
      <Box
        backgroundColor="grey.200"
        cursor="pointer"
        onClick={handleClick}
        padding="space-24"
        position="relative"
      >
        <Box position="absolute" right={24} textAlign="right" top={24}>
          <SunshineIcon color="primary" name="edit" size="icon-18" />
        </Box>
        <Center height={144}>
          <AnimatePresence initial={false} mode="wait">
            <motion.img
              {...animationProps}
              alt={field.value}
              key={animationIllustration}
              role="presentation"
              src={
                BANK_ACCOUNT_ILLUSTRATIONS[
                  (field.value ||
                    animationIllustration) as keyof BankAccountIllustrationsType
                ]
              }
              width={144}
            />
          </AnimatePresence>
        </Center>
      </Box>
      {isOpenIllustrationSidebar ? (
        <IllustrationPickerSidebar closeSidebar={toggleSidebar} field={field} />
      ) : null}
    </>
  );
};

export default BankAccountIllustrationPicker;
